import { sendEventToJumbo } from './jumbo';

export const CALLBACK_EVENTS = {
  INITIATE_CALLBACK_SUCCESS: 'initiate_callback_success',
  INITIATE_CALLBACK_FAILURE: 'initiate_callback_failure',
  CALL_ALERT_DETAILS_SUCCESS: 'call_alert_details_success',
  CALL_ALERT_DETAILS_FAILURE: 'call_alert_details_failure',
  CALL_ALERT_CONFIRM_EVENT: 'call_alert_confirm_event',
  REDIRECT_CALLBACK_SUCCESS: 'redirect_callback_success',
  REDIRECT_CALLBACK_FAILURE: 'redirect_callback_failure',
  CALLBACK_MODAL_OPEN: 'callback_modal_open',
  CALLBACK_MODAL_CLOSE: 'callback_modal_close',
  CALLBACK_TOAST_VISIBLE: 'callback_toast_visible',
  CALLBACK_TOAST_CLOSE: 'callback_toast_close',
};

export const sendCallbackApiEvents = (
  eventName,
  orderId,
  customerId,
  responseMeta,
) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    responseMeta,
  });
};

export const sendCallbackModalEvents = (
  eventName,
  orderId,
  customerId,
  responseMeta,
) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    responseMeta,
  });
};

export const sendCallbackToastEvents = (orderId, customerId, responseMeta) => {
  sendEventToJumbo({
    eventName: CALLBACK_EVENTS.CALLBACK_TOAST_SHOW,
    orderId,
    customerId,
    responseMeta,
  });
};
